import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MARGIN_GENERIC_WARNING_MESSAGE } from '../margin-approval.utils';

@Component({
  selector: 'app-margin-dialog-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './margin-dialog-content.component.html'
})
export class MarginDialogContentComponent {
  @Input() kind: 'item' | 'order' = 'item';
  @Input() actualMargin = 0;
  @Input() requiredMargin = 0;

  readonly message = MARGIN_GENERIC_WARNING_MESSAGE;
}
